import { createAction } from "@reduxjs/toolkit";
import type { AddTimelineEventBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const addTimelineEvent = createApiThunk<void, AddTimelineEventBody>(
  "timelineEvents/addTimelineEvent",
  async (body: AddTimelineEventBody, { extra: { adminRepository } }) => {
    return adminRepository!.createTimelineEvent(body);
  },
);

export const resetAddTimelineEvent = createAction("timelineEvents/resetAddTimelineEvent");
